'use client';

import { Flex, Text } from '@skin-seoul/design-system';
import { ClientOnly } from '@skin-seoul/utils';
import type { CountdownTime } from '../hooks/useCountdown';
type CountdownTimerProps = {
  time: CountdownTime;
};
type TimeUnitProps = {
  value: number;
  label: string;
};
const TimeUnit = ({
  value,
  label
}: TimeUnitProps) => {
  const displayValue = value.toString().padStart(2, '0');
  return <Flex direction="column" alignItems="center" gap={1} data-sentry-element="Flex" data-sentry-component="TimeUnit" data-sentry-source-file="CountdownTimer.tsx">
      <Text textStyle="heading.h3" fontWeight="bold" color="generic.0" data-sentry-element="Text" data-sentry-source-file="CountdownTimer.tsx">
        {displayValue}
      </Text>
      <Text textStyle="paragraph.medium" color="generic.0" fontWeight="medium" data-sentry-element="Text" data-sentry-source-file="CountdownTimer.tsx">
        {label}
      </Text>
    </Flex>;
};
const TimeSeparator = () => <Text textStyle="heading.h5" fontWeight="bold" color="generic.0" alignSelf="center" data-sentry-element="Text" data-sentry-component="TimeSeparator" data-sentry-source-file="CountdownTimer.tsx">
    :
  </Text>;
export const CountdownTimer = ({
  time
}: CountdownTimerProps) => {
  if (time.isExpired) {
    return null;
  }
  return <ClientOnly data-sentry-element="ClientOnly" data-sentry-component="CountdownTimer" data-sentry-source-file="CountdownTimer.tsx">
      <Flex direction="row" alignItems="flex-start" justifyContent={{
      base: 'space-around',
      desktop: 'flex-start'
    }} width={{
      base: '100%',
      desktop: 'auto'
    }} gap={{
      base: 2,
      desktop: 4
    }} data-sentry-element="Flex" data-sentry-source-file="CountdownTimer.tsx">
        <TimeUnit value={time.hours} label="Hours" data-sentry-element="TimeUnit" data-sentry-source-file="CountdownTimer.tsx" />
        <TimeSeparator data-sentry-element="TimeSeparator" data-sentry-source-file="CountdownTimer.tsx" />
        <TimeUnit value={time.minutes} label="Minutes" data-sentry-element="TimeUnit" data-sentry-source-file="CountdownTimer.tsx" />
        <TimeSeparator data-sentry-element="TimeSeparator" data-sentry-source-file="CountdownTimer.tsx" />
        <TimeUnit value={time.seconds} label="Seconds" data-sentry-element="TimeUnit" data-sentry-source-file="CountdownTimer.tsx" />
      </Flex>
    </ClientOnly>;
};